import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { useCookies } from 'react-cookie';
import { Button, Grid, Stack, Typography } from '@mui/material';
import { useGetRequestUrl } from '../hooks/useGetRequestUrl';
import { useNavigate } from 'react-router-dom';

export default function RecipeDetail() {
  const navigate = useNavigate();
  const requestUrl = useGetRequestUrl();
  const [cookies, _] = useCookies(['access_token']);
  const { id } = useParams();
  const [recipe, setRecipe] = useState({});
  const ingredients = recipe.ingredients;

  // if (!cookies.access_token) {
  //   return (
  //     <Stack justifyContent="center" alignItems="center">
  //       <Typography>Login to see the rcipe</Typography>
  //       <Button
  //         variant="contained"
  //         color="success"
  //         onClick={() => {
  //           navigate('/login');
  //         }}
  //       >
  //         Login
  //       </Button>
  //     </Stack>
  //   );
  // }

  useEffect(() => {
    const getRecipe = async () => {
      if (!cookies.access_token) {
        navigate('/login');
      }
      const response = await axios.get(
        `${requestUrl}/recipe/${id}`,
        {
          headers: { authorization: `Bearer ${cookies.access_token}` },
        },
        { withCredentials: false }
      );
      console.log(response.data);
      setRecipe(response.data);
    };
    getRecipe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!ingredients) {
    return <div>Loading...</div>;
  }
  return (
    <Grid
      container
      spacing={1}
      justifyContent="center"
      alignItems="center"
      mt="40px"
      mb="40px"
    >
      <Grid item xs={12} sm={12} md={6} lg={4} sx={{ minWidth: '100%,950px' }}>
        <img
          src={recipe.imageUrl}
          alt="recipe"
          height="300px"
          width="300px"
          className="recipe-card-img"
        />
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={4} ml={{ xs: '20px', md: '0px' }}>
        <h1>{recipe.title}</h1>
        <Typography fontSize="15px" fontWeight="500">
          {recipe.description}
        </Typography>
        <br />
        <Typography>Time to cook: {recipe.timeToCook} minutes</Typography>
        <br />

        <Stack gap={1}>
          <h3>Ingredients:</h3>
          {ingredients.map((ingredient) => (
            <Typography fontSize="15px" fontWeight="500" fontFamily="Ubuntu">
              ❤️ {ingredient}
            </Typography>
          ))}
        </Stack>
      </Grid>
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={4}
        sx={{ minWidth: '100%,950px' }}
        ml={{ xs: '20px', md: '0px' }}
      >
        <h3>Instructions:</h3>

        <Typography fontSize="15px">{recipe.instructions}</Typography>
      </Grid>
    </Grid>
  );
}
